<template>
  <CBottomPopup
    :title="title"
    :value="active"
    max-height="100%"
    get-container="#high-layer"
    @closed="$emit('cancel')"
    ><div class="c-datetime-picker">
      <div class="picker">
        <van-datetime-picker
          v-model="value"
          :type="type"
          :show-toolbar="false"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="formatter"
        />
      </div>
      <div class="footer c:row-center">
        <CButton large @click="confirm" primary>{{ confirmText }}</CButton>
      </div>
    </div>
  </CBottomPopup>
</template>

<script>
import CBottomPopup from "./CBottomPopup.vue";
import CButton from "./CButton.vue";

export default {
  components: { CBottomPopup, CButton },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "请选择",
    },
    type: {
      type: String,
      default: "date",
    },
    confirmText: {
      type: String,
      default: "确定",
    },
    initValue: {
      type: Date,
    },
    minDate: {
      type: Date,
    },
    maxDate: {
      type: Date,
    },
  },
  data() {
    return {
      value: new Date(),
    };
  },
  watch: {
    initValue: {
      handler: function (date) {
        // console.log("initValue", date);
        if (date) {
          this.value = date;
        } else {
          this.value = new Date();
        }
      },
      immediate: true,
    },
  },
  methods: {
    formatter(type, val) {
      //   console.log(type, val);
      switch (type) {
        case "year":
          return `${val}年`;
        case "month":
          return `${val}月`;
        case "day":
          return `${val}日`;

        default:
          return val;
      }
    },
    confirm() {
      //   console.log("confirm", this.value);
      this.$emit("confirm", this.$moment(this.value));
    },
  },
};
</script>

<style lang="less" scoped>
.c-datetime-picker {
  .picker {
    width: 100%;
    height: auto;
    padding: 0 4/20rem 20/20rem;
  }
  .footer {
    gap: 12/20rem;

    width: 100%;
    height: 62/20rem;
    padding: 8/20rem 20/20rem 20/20rem;

    .footer-btn {
      flex: 1;
      width: 0;
      height: 46/20rem;

      &.primary {
        background-color: #000;
        color: #fff;
      }
    }
  }
}
</style>
